import React from "react";

const CreateTemplate = () => {
  return <div>CreateTemplate</div>;
};

export default CreateTemplate;
